import {environment} from '../../../environments/environment';

const PARAMS_TEMPLATE = /[{]\w+[}]+/;

const replaceParams = (url: string, params: any[]): string => {
  if (!params.length) {
    return url;
  }

  if (!url.match(PARAMS_TEMPLATE)) {
    return url;
  }

  const parts = url.split(PARAMS_TEMPLATE);
  let finalUrl = '';
  const partsQuantity = parts.length - 1;

  parts.forEach((part, index) => {
    if (index === partsQuantity - 1 && part.length === 0) {
      return;
    }
    const value = params.length > index ? params[index] : '';
    finalUrl += `${parts[index]}${value}`;
  });


  return finalUrl;
};

const addQuery = (url: string, query: Object) => {
  let finalQuery = '';
  const finalQueryTemp = [];

  const queriesKeys = Object.keys(query);

  if (!queriesKeys.length) {
    return url;
  }

  queriesKeys.forEach((paramName => {
    const paramValue = query[paramName];
    const encodedParamValue = encodeURIComponent(paramValue)
    finalQueryTemp.push(`${paramName}=${encodedParamValue}`);
  }));

  finalQuery = finalQueryTemp.join('&');

  return url.indexOf('?') !== -1 ? `${url}&${finalQuery}` : `${url}?${finalQuery}`;
};


const toUrl = (url: string, params: string [] | number[] = [], query: Object = {}, isProduction = environment.production): string => {
  const finalUrl = replaceParams(url, params);
  const finalUrlWithQuery = addQuery(finalUrl, query);

  if (!isProduction) {
    console.log(`In development mode to the url is NOT added. Final url will be ${finalUrlWithQuery}`);
    return finalUrl;
  }

  return finalUrlWithQuery;
};


export default toUrl;
